import EntitlementTabList from './EntitlementTabList';
export default EntitlementTabList;
